import { useEffect, useRef, useState } from 'react';
const pcBanners = [
  '/assets/images/header/banner_pc_8.jpg',
  '/assets/images/header/banner_pc_7.jpg',
  '/assets/images/header/banner_pc_11.jpg',
  '/assets/images/header/banner_pc_2.jpg',
  '/assets/images/header/banner_pc_4.jpg',
  '/assets/images/header/banner_pc_5.jpg',
  '/assets/images/header/banner_pc_6.jpg'
];
const mbBanners = [
  '/assets/images/header/banner_mb_8.jpg',
  '/assets/images/header/banner_mb_7.jpg',
  '/assets/images/header/banner_mb_1.jpg',
  '/assets/images/header/banner_mb_2.jpg',
  // '/assets/images/header/banner_mb_3.jpg',
  '/assets/images/header/banner_mb_4.jpg',
  '/assets/images/header/banner_mb_5.jpg'
];

export default function BannerSlider() {
  const [index, setIndex] = useState(0);
  const timeoutRef = useRef();

  const isMobile = typeof window !== 'undefined' ? window.innerWidth < 768 : false;

  const banners = isMobile ? mbBanners : pcBanners;

  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      setIndex((prev) => (prev + 1) % banners.length);
    }, 3500);
    return () => clearTimeout(timeoutRef.current);
  }, [index, banners.length]);

  // Avoid SSR hydration issues if window is undefined
  if (typeof window === 'undefined') return null;

  return (
    <div className="w-full h-auto flex justify-center items-center relative">
      {/* Banner image */}
      <img
        src={banners[index]}
        alt={`Banner ${index + 1}`}
        className={`w-full h-auto object-contain ${isMobile ? 'md:hidden flex' : 'md:flex hidden'}`}
        style={{ transition: 'opacity 0.5s' }}
      />

      {/* Dots pagination */}
      <div className="absolute bottom-1 left-1/2 transform -translate-x-1/2 flex flex-row gap-2 z-10">
        {banners.map((_, i) => (
          <button
            key={i}
            className={`w-2 h-2 rounded-full border ${
              index === i ? 'bg-[#006719] border-[#006719]' : 'bg-white border-gray-300'
            }`}
            style={{ opacity: index === i ? 1 : 0.6 }}
            onClick={() => setIndex(i)}
            tabIndex={-1}
            aria-label={`Go to banner ${i + 1}`}
            type="button"
          />
        ))}
      </div>
    </div>
  );
}
